export const SPECS_SCOPE = 'site-search';

export const enum Spec {
  FluidLayout = 'specs.siteSearch.EnableFluidLayoutInSearchResultsWidget',
  Sorting = 'specs.siteSearch.EnableSorting',
}
